import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { GlobalFooterBottom } from "./global-footer-bottom";
import { GlobalFooterTop } from "./global-footer-top";

const globalFooterStyle = css({
    backgroundColor: "#fff",
    padding: token("space.200"),
    display: "flex",
    flexDirection: "column",
    gap: token("space.200")
});

export type GlobalFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

export const GlobalFooter = ({
    selectedLanguage,
    onLanguageChangeHandler
}: GlobalFooterPatternProps) => (
    <UFOSegment name="global-footer-v2">
        <footer css={globalFooterStyle}>
            <GlobalFooterTop />
            <GlobalFooterBottom
                selectedLanguage={selectedLanguage}
                onLanguageChangeHandler={onLanguageChangeHandler}
            />
        </footer>
    </UFOSegment>
);
